import(/* webpackMode: "eager" */ "/var/www/client/src/app/(category-list)/[category]/loading.tsx");
